import { doUpdateCompanyProfile } from '../../ducks/companyProfile'
import { selectNextPage } from './selectors'

export const doSave = ({
  numberOfEmployeesInput,
  customHelpInput,
  industryInput,
}) => {
  return (dispatch, getState) => {
    const state = getState()
    const ret = dispatch(
      doUpdateCompanyProfile({
        numberOfEmployees: numberOfEmployeesInput,
        currentSupportSolution: customHelpInput,
        industry: industryInput,
      })
    )
    dispatch({
      type: selectNextPage(state),
    })
    return ret
  }
}
